var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useShowScrollHint } from '../hooks';
import { Text } from '../text';
import { useModal } from './modal-context';
import { bodyShadowsStyle, bodyStaticStyle, bodyWrapperStaticStyle, } from './styles';
function Body(_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    var bodyRef = useRef(null);
    var _b = useShowScrollHint(bodyRef, 'vertical'), isShadowBottomVisible = _b.showEndHint, isShadowTopVisible = _b.showStartHint;
    var _c = useModal(), bodyId = _c.bodyId, id = _c.id, setBodyId = _c.setBodyId, size = _c.size;
    useEffect(function () {
        setBodyId("".concat(id, "-body"));
    }, [id, setBodyId]);
    return (_jsxs("div", __assign({ css: bodyWrapperStaticStyle }, { children: [_jsx("div", { css: (isShadowTopVisible || isShadowBottomVisible) &&
                    bodyShadowsStyle({
                        isShadowBottomVisible: isShadowBottomVisible,
                        isShadowTopVisible: isShadowTopVisible,
                    }) }), _jsx(Text, __assign({ as: "div", css: bodyStaticStyle, id: bodyId, ref: bodyRef }, __assign({ size: size }, restProps), { children: children }))] })));
}
export default Body;
